import React from 'react';
import T from 'prop-types';
import AOList from './aolist';

const AOListBlock = (props) => {
  const ao = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'å',
    'ä',
    'ö',
  ];

  if (props.ActivateDigitGrouping) {
    ao.unshift('#');
  }
  const dataPrintSidebarTitle = props.CurrentPageProps?.Content?.Translations?.aolistblock || '';

  return (
    <AOList
      alphabet={ao}
      compare={(item) => {
        const listitem = props.AOList.Items.find(
          (x) => x.Key.toLowerCase() === item.Key.toLowerCase()
        );
        return listitem && listitem.Items;
      }}
      id={props.UniqueBlockId}
      list={props.AOList.Items}
      dataPrintSidebarTitle={dataPrintSidebarTitle}
    />
  );
};

AOListBlock.propTypes = {
  Items: T.arrayOf(
    T.shape({
      Key: T.string,
    })
  ),
  UniqueBlockId: T.string,
};

export default AOListBlock;
